module.exports = __webpack_public_path__ + "img/like-def.1a3ec990.png";